import React from 'react';


class LinkPicker extends React.Component {
    constructor(props) {
        super(props);

        
        this.defaultState = this.defaultState.bind(this);
        this.onUrlChange = this.onUrlChange.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.output = this.output.bind(this);

        this.defaultState(props);

        
    }

    defaultState(props) {
        this.state = {
            enabled:false,
            url:'',
            timestamp:new Date().getMilliseconds()       
        };



        if(props.data) {
            this.state.enabled = props.data.enabled;
            this.state.url = props.data.url;
       
        }

        
    }

    output() {
        let changes = {
            'url':this.state.url,
            'enabled':this.state.enabled,
        };



        this.props.handleLinkChange(this.props.data.id,changes);
    }

    componentWillReceiveProps(nextProps) {
        this.defaultState(nextProps);
    }

    componentDidUpdate(prevObject, prevState) {
       if(this.state.timestamp != prevState.timestamp) {
           this.output();
       }
    }

    onUrlChange(e) {
    	let change = {url:e.target.value,timestamp:new Date().getMilliseconds()};
        if(e.target.value != '') {
            change.enabled = true;
        }
    	this.setState(change);
    }

    onCheckboxChange(e) {
        let key = e.target.getAttribute('data-key');
        let val = !this.state[key];
        let change = { [key]:val,timestamp:new Date().getMilliseconds()};

        if(key == 'enabled' && val == false) {
            change.url = '';
        }


        this.setState(change);
    }

    render() {
        let style = 'col-sm-9 p-2';

        if(this.props.onlyPickUrl === true) {
            style = 'col-sm-12 p-0';
        }
        return (
            <div className="col-sm-12 p-0">
                {(this.props.onlyPickUrl !== true) ? 
                    <div className="col-sm-3 p-0">
                        <div className="checkbox-custom checkbox-default">
                            <input type="checkbox" checked={this.state.enabled} data-key="enabled" onChange={this.onCheckboxChange} />
                            <label>Enabled</label>
                        </div>
                    </div>
                    :
                    null
                }
                

                <div className={style}>
                    <input type="text" className="form-control" value={this.state.url} onChange={this.onUrlChange} placeholder="Web address" />
                </div>
                
            </div>
        );
    }

  
}

export default LinkPicker;




// WEBPACK FOOTER //
// ./components/builder/LinkPicker.js